export default {
  styleOverrides: {
    root: {
      width: 42,
      height: 26,
      padding: 0,
    },

    switchBase: {
      padding: 1,
      color: '#ffffff',

      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#ffffff',

        '& + .MuiSwitch-track': {
          backgroundColor: 'var(--color-primary)',
          opacity: 1,
          border: 'none',
        },
      },

      '&.Mui-disabled': {
        color: '#ffffff',

        '& + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },

      '&:hover': {
        backgroundColor: 'var(--color-action-hover)',
      },
    },

    thumb: {
      width: 24,
      height: 24,
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
    },

    track: {
      borderRadius: 13,
      backgroundColor: 'var(--color-border)',
      opacity: 1,
      transition: 'background-color 0.2s ease',
    },
  },
};
